/* NFA mobile-only motion. No animation libraries and no scroll handlers. */
(function () {
  var cfg = window.NFA_SETTINGS || {};
  if (!cfg.mobileMotion) return;

  var mobile = window.matchMedia('(max-width: 749px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!mobile.matches || reduced.matches) return;

  var root = document.documentElement;
  root.classList.add('nfa-mobile-motion');

  function initCardReveals() {
    if (!('IntersectionObserver' in window)) return;
    var items = document.querySelectorAll('.product-grid .grid__item, .collection-list .grid__item');
    if (!items.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('nfa-reveal-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });

    items.forEach(function (el, i) {
      el.classList.add('nfa-reveal-pending');
      el.style.setProperty('--nfa-reveal-delay', ((i % 4) * 45) + 'ms');
      io.observe(el);
    });
  }

  function initDrawerMotion() {
    var details = document.getElementById('Details-menu-drawer-container');
    var drawer = document.getElementById('menu-drawer');
    if (!details || !drawer || !('MutationObserver' in window)) return;

    function sync() {
      if (details.hasAttribute('open')) {
        drawer.classList.remove('nfa-drawer-open');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { drawer.classList.add('nfa-drawer-open'); });
        });
      } else {
        drawer.classList.remove('nfa-drawer-open');
      }
    }
    new MutationObserver(sync).observe(details, { attributes: true, attributeFilter: ['open'] });
    sync();
  }

  function init() {
    initCardReveals();
    initDrawerMotion();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
